import { render } from "./Career.vue?vue&type=template&id=f987661c"
import script from "./Career.vue?vue&type=script&lang=js"
export * from "./Career.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Career.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f987661c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f987661c', __exports__)) {
    api.reload('f987661c', __exports__)
  }
  
  module.hot.accept("./Career.vue?vue&type=template&id=f987661c", () => {
    api.rerender('f987661c', render)
  })

}


export default __exports__